<script>
	import { Datepicker } from "svelte-calendar";
	import { PRConnect } from "@projectroom/ui-lib";
	import { onMount } from "svelte";
	import axios from "axios";
	import EmojiSelector from "svelte-emoji-selector";
	import VanillaCalendar from "vanilla-calendar-pro";
	import "vanilla-calendar-pro/build/vanilla-calendar.min.css";

	export let event;
	let refPopupTitle;
	let refPopupLink;
	let isShowResultDate;
	$: if (event.currentTab === "management" && event.isLoad) {
		isShowResultDate = event.eventType == "LINK";
		setCalendar("#calendar-start");
		setCalendar("#calendar-end");
		setCalendar("#calendar-result");
	}
	onMount(() => {});

	const setCalendar = (target) => {
		const options = {
			input: true,
			actions: {
				changeToInput(
					e,
					calendar,
					dates,
					time,
					hours,
					minutes,
					keeping
				) {
					if (dates[0]) {
						calendar.HTMLInputElement.value = dates[0];
						// if you want to hide the calendar after picking a date
						calendar.HTMLInputElement.click();
						calendar.hide();
					} else {
						calendar.HTMLInputElement.value = "";
					}
				},
			},
		};
		const calendar = new VanillaCalendar(target, options);
		calendar.init();
	};
	const changeDate = (e) => {
		const root = e.target.closest(".event-date-picker");
		const type = root.dataset.type;
		const day = root.querySelector(".calendar-day").value;
		const hour = root.querySelector(".calendar-hour").value;
		event.changeDate(type, day, hour);
	};

	const onEmoji = (e) => {
		changePopupTitle(e.detail);
	};

	const changePopupTitle = (addedContext='') => {
		const popupTitle =
			refPopupTitle.value.slice(0, refPopupTitle.selectionEnd) +
			addedContext +
			refPopupTitle.value.slice(refPopupTitle.selectionEnd);
		event.changePopupTitle(popupTitle);
	};

	const changePopupLink = () => {
		event.changePopupLink(refPopupLink.value);
	}

	const clickReceiveContent = (content) => {
		event.changeReceiveContent(content);
	};

	const clickEventType = (eventType) => {
		event.changeEventType(eventType);
	};
</script>

<div
	data-w-tab="Tab 5"
	class="w-tab-pane"
	id="event-management"
	class:w--tab-active={event.currentTab === "management"}
>
	{#if event.isLoad}
		<div class="event-admin-write-wrap">
			<div class="event-write">
				<div class="admin-title-text _2">이벤트 관리 기간</div>
				<div class="event-date-pickerform">
					<div class="event-date-picker-wrap">
						<div class="admin-title-text">
							이벤트 시작일을 선택해주세요.
						</div>
						<div class="event-date-picker" data-type="startDate">
							<div
								data-hover="false"
								data-delay="0"
								class="w-dropdown"
							>
								<div
									class="a-data-picker w-dropdown-toggle"
									aria-controls="w-dropdown-list-3"
									aria-haspopup="menu"
									aria-expanded="false"
									role="button"
									tabindex="0"
								>
									<input
										class="calendar-day"
										type="text"
										value={event.getStartDay()}
										id="calendar-start"
										placeholder="choose date"
										on:click={changeDate}
										readonly
									/>
								</div>
							</div>
							<div
								data-hover="false"
								data-delay="0"
								class="w-dropdown"
							>
								<div
									class="dropdown-toggle-5 w-dropdown-toggle"
									id="w-dropdown-toggle-4"
									aria-controls="w-dropdown-list-4"
									aria-haspopup="menu"
									aria-expanded="false"
									role="button"
									tabindex="0"
								>
									<input
										class="calendar-hour"
										type="number"
										placeholder="0"
										min="1"
										max="23"
										value={event.getStartTime()}
										on:change={changeDate}
									/>시
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="event-date-picker-wrap">
					<div class="admin-title-text">
						이벤트 마감일을 선택해주세요.
					</div>
					<div class="event-date-picker" data-type="endDate">
						<div
							data-hover="false"
							data-delay="0"
							class="w-dropdown"
						>
							<div
								class="a-data-picker w-dropdown-toggle"
								aria-controls="w-dropdown-list-3"
								aria-haspopup="menu"
								aria-expanded="false"
								role="button"
								tabindex="0"
							>
								<input
									class="calendar-day"
									type="text"
									value={event.getEndDay()}
									id="calendar-end"
									placeholder="choose date"
									on:click={changeDate}
									readonly
								/>
							</div>
						</div>
						<div
							data-hover="false"
							data-delay="0"
							class="w-dropdown"
						>
							<div
								class="dropdown-toggle-5 w-dropdown-toggle"
								id="w-dropdown-toggle-4"
								aria-controls="w-dropdown-list-4"
								aria-haspopup="menu"
								aria-expanded="false"
								role="button"
								tabindex="0"
							>
								<input
									class="calendar-hour"
									type="number"
									placeholder="0"
									min="1"
									max="23"
									value={event.getEndTime()}
									on:change={changeDate}
								/>시
							</div>
						</div>
					</div>
				</div>
				
				<div class="event-date-picker-wrap" class:hide={isShowResultDate}>
					<div class="admin-title-text">
						결과발표일을 선택해주세요.
					</div>
					<div class="event-date-picker" data-type="resultDate">
						<div
							data-hover="false"
							data-delay="0"
							class="w-dropdown"
						>
							<div
								class="a-data-picker w-dropdown-toggle"
								aria-controls="w-dropdown-list-3"
								aria-haspopup="menu"
								aria-expanded="false"
								role="button"
								tabindex="0"
							>
								<input
									class="calendar-day"
									type="text"
									value={event.getResultDay()}
									id="calendar-result"
									placeholder="choose date"
									on:click={changeDate}
									readonly
								/>
							</div>
						</div>
						<div
							data-hover="false"
							data-delay="0"
							class="w-dropdown"
						>
							<div
								class="dropdown-toggle-5 w-dropdown-toggle"
								id="w-dropdown-toggle-4"
								aria-controls="w-dropdown-list-4"
								aria-haspopup="menu"
								aria-expanded="false"
								role="button"
								tabindex="0"
							>
								<input
									class="calendar-hour"
									type="number"
									placeholder="0"
									min="1"
									max="23"
									value={event.getResultTime()}
									on:change={changeDate}
								/>시
							</div>
						</div>
					</div>
				</div>
				
				<div class="admin-title-text _2">이벤트 참여 팝업</div>
				<div class="event-infomation-text">
					<div class="linktext-block-form">
						<div class="text-block-94">이벤트 타입</div>
						<div class="event-type-wrapper">
							<div
								class="event-type"
								class:active-type={event.isEventType(
									"RECOMMEND"
								)}
								on:click={() => clickEventType("RECOMMEND")}
							>
								추천인 링크 부여받기
							</div>
							<div
								class="event-type"
								class:active-type={event.isEventType("DEFAULT")}
								on:click={() => clickEventType("DEFAULT")}
							>
								일반 이벤트
							</div>
							<div
								class="event-type"
								class:active-type={event.isEventType("LINK")}
								on:click={() => clickEventType("LINK")}
							>
								링크 연결형 이벤트
							</div>
						</div>
						{#if event.eventType === "LINK"}
						<div class="text-block-94">이벤트 버튼 클릭시 넘어가는 링크입력</div>
						<div class="linktext-input-form-copy w-form">
							<div class="link-form admin">
								<input
									type="text"
									class="name-text-form w-input"
									autofocus="true"
									maxlength="256"
									name="name-4"
									data-name="Name 4"
									placeholder="버튼에 쓰일 문구를 넣어주세요.예)공모전 참여하기"
									id="name-4"
									bind:this={refPopupTitle}
									value={event.popupTitle}
									on:change={() => changePopupTitle()}
								/>
							</div>
							<div class="link-form admin">
								<input
									type="text"
									class="name-text-form w-input"
									autofocus="true"
									maxlength="256"
									name="name-4"
									data-name="Name 4"
									placeholder="버튼에 적용할 링크를 넣어주세요"
									id="name-4"
									bind:this={refPopupLink}
									value={event.popupLink}
									on:change={() => changePopupLink()}
								/>
							</div>
						</div>
						{:else}
						<div class="text-block-94">타이틀 텍스트</div>
						<div class="linktext-input-form-copy w-form">
							<div class="link-form admin" id="email-form">
								<input
									type="text"
									class="name-text-form w-input"
									autofocus="true"
									maxlength="256"
									name="name-4"
									data-name="Name 4"
									placeholder="예) 아바톡 이벤트에 참여해보자!"
									id="name-4"
									bind:this={refPopupTitle}
									value={event.popupTitle}
									on:change={() => changePopupTitle()}
								/>
								<EmojiSelector on:emoji={onEmoji} />
							</div>
						</div>
						{/if}
					</div>
					<div class="personal-data-block-form margin20">
						{#if event.eventType !== "LINK"}
						<div class="text-block-107">받아 볼 고객정보</div>
						<div class="checkbox-wrap">
							<div
								class="checkbox-elements"
								on:click={() => clickReceiveContent("name")}
							>
								<img
									alt=""
									loading="lazy"
									src="/static/images/check-icon.svg"
									class="chracter-checkbox"
									class:active={event.isReceiveContent(
										"name"
									)}
								/>
								<div class="text-block-95">성함</div>
							</div>
							<div
								class="checkbox-elements"
								on:click={() => clickReceiveContent("email")}
							>
								<img
									alt=""
									loading="lazy"
									src="/static/images/check-icon.svg"
									class="chracter-checkbox"
									class:active={event.isReceiveContent(
										"email"
									)}
								/>
								<div class="text-block-95">이메일</div>
							</div>
							<div
								class="checkbox-elements"
								on:click={() => clickReceiveContent("phone")}
							>
								<img
									alt=""
									loading="lazy"
									src="/static/images/check-icon.svg"
									class="chracter-checkbox"
									class:active={event.isReceiveContent(
										"phone"
									)}
								/>
								<div class="text-block-95">전화번호</div>
							</div>
							<div
								class="checkbox-elements"
								on:click={() => clickReceiveContent("insta")}
							>
								<img
									alt=""
									loading="lazy"
									src="/static/images/check-icon.svg"
									class="chracter-checkbox"
									class:active={event.isReceiveContent(
										"insta"
									)}
								/>
								<div class="text-block-95">인스타 주소</div>
							</div>
						</div>
						{/if}
					</div>
					{#if event.eventType !== "RECOMMEND"}
						<div class="text-block-107">이벤트 공유하기 버튼</div>
						<div class="lanking-setting">
							<div
								class="toggle-button _2"
								on:click={event.changeEventShareFlag()}
							>
								<div
									class="toggle"
									class:on={event.isEventShareFlag()}
								/>
								<div
									class="toggle-round"
									class:on={event.isEventShareFlag()}
								/>
							</div>
						</div>
						{/if}
				</div>
			</div>
		</div>
	{/if}
</div>

<style>
	.w-dropdown {
		z-index: 0;
	}
	.calendar-day {
		align-items: center;
		height: 30px;
		border: 0;
		padding: 5px 10px;
		box-sizing: border-box;
		width: 100px;
		outline: 0;
		font-size: 14px;
		line-height: 1;
		border: 1px solid #0f172a;
		border-radius: 4px;
		background-color: white;
	}

	.calendar-hour {
		align-items: center;
		height: 30px;
		border: 0;
		padding: 5px 10px;
		box-sizing: border-box;
		width: auto;
		outline: 0;
		font-size: 14px;
		line-height: 1;
		border: 1px solid #0f172a;
		border-radius: 4px;
		background-color: white;
		margin-right: 8px;
	}
	.a-data-picker {
		width: auto;
		border: none;
	}
	.dropdown-toggle-5 {
		border: none;
	}
	.event-type {
		background-color: rgba(107, 55, 255, 0.06);
		border-width: 1px;
		border-color: #6b37ff;
		border-radius: 3px;
		display: inline-block;
		width: 200px;
		text-align: center;
		padding: 10px;
		margin-right: 10px;
		border: 1px solid #6b37ff;
		font-size: 14px;
		font-weight: 600;
	}
	.link-form {
		position: relative;
	}

	.event-type-wrapper {
		margin-bottom: 20px;
	}

	.active {
		background-color: #4c4fa7;
	}
	.checkbox-elements {
		cursor: pointer;
	}
	.event-type {
		cursor: pointer;
	}
	.active-type {
		background-color: #7462e6;
	}
	.toggle.on {
		border-color: #ff558d;
		border-radius: 30px;
		background-color: #ff558d;
	}

	.toggle {
		background-color: #999;
	}

	.checkbox-wrap {
		margin-bottom: 20px;
	}

	.linktext-input-form-copy {
		margin-bottom: 20px;
	}

</style>
